'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import BusinessModals from '@components/BusinessModal/businessModals'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { EVENT_TYPE, TAP_EVENT, VIEW_LEAD_GEN_POPUP } from '@constants/enterpriseSegmentData'
import styles from './enterpriseBusinessCategory.module.scss'

const Index = ({ data }) => {
  const { title, subtitle, categoryImageUrl, FeatureList, actionText, actionIconUrl, category, formSnippet } = data?.data
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (isModalOpen) {
      sendEnterpriseEvent({ view_name: VIEW_LEAD_GEN_POPUP }, EVENT_TYPE.VIEW)
    }
  }, [isModalOpen])

  return (
    <div id={category} className={styles.main}>
      <h2 className={styles.mainTitle}>{title}</h2>
      <h3 className={styles.mainSubtitle}>{subtitle}</h3>
      <div className={styles.infoCard}>
        <div className={styles.imageContainer}>
          <div
            className={styles.categoryImage}
            style={{ backgroundImage: `url(${categoryImageUrl?.data?.attributes?.url})` }}
          />
        </div>
        <div className={styles.infoCardContent}>
          {FeatureList?.length > 0 ? (
            <div className={styles.head}>
              <div className={styles.titleIconContainer}>
                <Image
                  src={FeatureList[0]?.featureIconUrl?.data?.attributes?.url}
                  alt={FeatureList[0]?.heading}
                  width={32}
                  height={32}
                  loading="lazy"
                />
              </div>
              <div>
                <div className={styles.title}>{FeatureList[0]?.heading}</div>
                <div className={styles.subtitle}>{FeatureList[0]?.subHeading}</div>
              </div>
            </div>
            ) : null
          }
          {FeatureList?.length > 0
            ? <div className={styles.description}>{FeatureList[0]?.description}</div>
            : null
          }
          <div className={styles.featureList}>
            {FeatureList?.map((feature, index) => index === 0
              ? null
              : (
                <div key={index} className={styles.feature}>
                  <div className={styles.featureIcon}>
                    <Image
                      src={feature?.featureIconUrl?.data?.attributes?.url}
                      alt={feature?.heading}
                      width={24}
                      height={24}
                      loading="lazy"
                    />
                  </div>
                  <div className={styles.featureTitle}>{feature?.heading}</div>
                  <div className={styles.description}>{feature?.description}</div>
                </div>
              )
            )}
          </div>
          {actionText && (
            <div className={styles.actionContainer} onClick={() => {
              sendEnterpriseEvent({ action_name: actionText, view_name: VIEW_LEAD_GEN_POPUP, action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP })
              setIsModalOpen(!isModalOpen)
            }}>
              <div className={styles.actionText}>{actionText}</div>
              <Image
                src={actionIconUrl?.data?.attributes?.url}
                alt="action icon"
                width={16}
                height={16}
                loading="lazy"
              />
            </div>
          )}
        </div>
      </div>
      <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
    </div>
  )
}

export default Index
